import { render, staticRenderFns } from "./PurPT.vue?vue&type=template&id=567c6b14&scoped=true"
import script from "./PurPT.vue?vue&type=script&lang=js"
export * from "./PurPT.vue?vue&type=script&lang=js"
import style0 from "./_layout.css?vue&type=style&index=0&id=567c6b14&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567c6b14",
  null
  
)

export default component.exports